import React from "react";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  DialogSystemGLPure,
  GridDocumentTrackingPure,
  ButtonHLPure,
  InteractiveDialog,
  HeaderHLPure,
  TextAreaHLPure
} from "../../pures";
import { useTranslation } from "react-i18next";

import "./document-tracking.css";

const DocumentTrackingView = (props) => {
  const { t } = useTranslation();

  // Container custom styles
  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    padding: "20px",
    width: "auto",
  };
  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }
  const containerTableAndHeadersStyles = {
    marginTop: "20px",
    maxWidth: "100%",
    justifyContent: "start",
  };

  const documentCell = (props) => {
    return <td>
      <p>{props.dataItem}</p>
    </td>
  }

  const headerCell = (props) => {
    return <span className="DocumentTrackingView-title-text-request">{props.title}</span>;
  }

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          <HeaderHLPure title={props.title} />

          <Grid
            container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className="container-grid-tracking"
          >
            <Grid
              item
              xs={12}
              lg={12}
              md={12}
              sm={12}
              className="container-description"
            >
              <Grid container spacing={2}>
                <Grid item xs={12} className="custom-detail-container">
                  <div className="custom-detail-inner">
                    <div className="custom-detail-section">
                      <p className="custom-detail-label">{t("documentTracking.request")}</p>
                      <span className="custom-detail-value">
                        {props.signRequest?.solicitudeName || props?.signRequest?.inbox?.solicitudeName || '-'}
                      </span>
                    </div>
                    <div className="custom-detail-section">
                      <p className="custom-detail-label">{t("documentTracking.document")}</p>
                      <p className="custom-detail-value">
                        {props.documents.length > 0
                          ? props.documents.map(doc => doc.name || doc).join(", ")
                          : props.fileNameDoc || '-'}
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className='container-document-tracking'>
              <div
                className='tracking-layout-container'
              >
                <div className='tracking-rectangle-column'>
                  {props?.statuses?.map((stage, index) => (
                    <div key={index} className='tracking-vertical-stage'>
                      {/* Indicador de diagrama de flujo */}
                      <div
                        className={`
                          tracking-rectangle
                          ${stage.isComplete ? 'completed' : ''}
                          ${stage.actualProcess && (stage.signRequest?.authorizedPending || stage.signRequest?.signPending) ? 'current' : ''}
                          ${stage.isFuture ? 'future' : ''}
                          ${stage.isFinalized ? 'finish' : ''}
                          ${stage.signRequest?.authorized || stage.signRequest?.signed ? 'signed-box' : ''}
                          `}
                      >
                        {/* Caso de autorización */}
                        {stage.key === 'workflowStatusSR200205' ? (
                          stage.signRequest?.authorizedPending ? (
                            `${stage.signRequest.signer?.userFirstName || ''} ${stage.signRequest.signer?.userFirstLastName || ''}`
                          ) : stage.signRequest?.authorized ? (
                            `${t('documentTracking.authorized')} - ${stage.signRequest.signer?.userFirstName || ''} ${stage.signRequest.signer?.userFirstLastName || ''}`
                          ) : (
                            t(`eventTypes.${stage.key}`, { defaultValue: stage.name })
                          )
                        ) : stage.key === 'workflowStatusSR200210' ? (
                          /* Caso de firma */
                          stage.signRequest?.signed ? (
                            `${t('documentTracking.signed')} - ${stage.signRequest.signer?.userFirstName || ''} ${stage.signRequest.signer?.userFirstLastName || ''}`
                          ) : stage.signRequest?.signPending ? (
                            <span>
                              {`${stage.signRequest.signer?.userFirstName || ''} ${stage.signRequest.signer?.userFirstLastName || ''}`}
                            </span>
                          ) : (
                            `${stage.signRequest.signer?.userFirstName || ''} ${stage.signRequest.signer?.userFirstLastName || ''}`
                          )
                        ) : (
                          /* por defecto */
                          t(`eventTypes.${stage.key}`, { defaultValue: stage.name })
                        )}
                      </div>

                      {/* Proceso actual */}
                      {stage.actualProcess &&
                        !props.isCanceled &&
                        (
                          (stage.key === 'workflowStatusSR200205' && stage.signRequest?.authorizedPending) ||
                          (stage.key === 'workflowStatusSR200210' && stage.signRequest?.signPending)
                        ) && (
                          <div className='tracking-rectangle in-progress-box'>
                            {t('documentTracking.progress')}
                          </div>
                        )}

                      {index !== props?.statuses?.length - 1 && (
                        <div className='tracking-arrow'>↓</div>
                      )}
                    </div>
                  ))}
                </div>

                <div style={{ flex: 1 }}>
                  <GridDocumentTrackingPure
                    dataStateChange={props.dataStateChange}
                    {...props}
                    onCommentClick={props.onCommentClick}
                  />
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
              className="btns-taxData"
            >
              <ButtonHLPure
                nameBtn={t("button.back")}
                onClickBtn={props.onBack}
              />
            </Grid>
            {/* Componet pure "Promotional footer" */}
            <Grid
              item
              xs={12}
              lg={12}
              md={12}
              sm={12}
              style={containerTableAndHeadersStyles}
            >
              <PromotionalFooterPure />
            </Grid>
          </Grid>

          {/* Alerts of Notification Completed and Loadign */}
          <DialogSystemGLPure
            {...props}
            toggleLoadingRequesting={props.toggleLoadingRequesting}
            toggleCompletedRequesting={props.toggleCompletedRequesting}
            toggleErrorRequesting={props.toggleErrorRequesting}
          />

          {
            props.showCommentModal && (
              <InteractiveDialog
                title={t('signatureReceivePanelView2.modal.title.comment')}
                cancelBtnTitle={t('button.return')}
                onClose={props.closeModal}
              >
                <TextAreaHLPure
                  labelTextArea={t('documentTracking.cancellationReason')}
                  characterLimit={500}
                  handleChangeTextArea={props.handleCommentsDelete}
                  rowsTextArea={5}
                  valueTextData={props.currentComment}
                />
              </InteractiveDialog>
            )
          }

        </Container>
      )}
    </div>
  );
};

export { DocumentTrackingView as default };
